import { render, staticRenderFns } from "./PaymentWidgets.vue?vue&type=template&id=6985b148&scoped=true&"
import script from "./PaymentWidgets.vue?vue&type=script&lang=js&"
export * from "./PaymentWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6985b148",
  null
  
)

export default component.exports